// generated from 10_227 samples

import { z } from "zod";
import { common } from "../common";
import { triggerAdditionalKeywordFiltersGetSchema } from "./triggerAdditionalKeywordFiltersGetSchema";

export const sentWhatsAppInboundMessageTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::SentWhatsAppInboundMessage"),
  additional_keyword_filters: triggerAdditionalKeywordFiltersGetSchema,
  subscription_group: z.object({
    id: common.objectId,
    name: z.string(),
  }),
});
